export default __webpack_public_path__ + "static/media/blog1.519dcdc8.jpg";